import { render, staticRenderFns } from "./ExtratoAutorizacaoItem.vue?vue&type=template&id=2855cb62"
import script from "./ExtratoAutorizacaoItem.vue?vue&type=script&lang=js"
export * from "./ExtratoAutorizacaoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports